import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 48 48"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("desc", null, "Lock Open Right Streamline Icon: https://streamlinehq.com", -1),
    _createElementVNode("path", { d: "M11 41h26V19.3H11zm13.009-7q1.59 0 2.716-1.101c1.126-1.102 1.125-1.618 1.125-2.649q0-1.5-1.134-2.725T23.991 26.3q-1.59 0-2.716 1.225-1.125 1.225-1.125 2.75c0 1.525.378 1.892 1.133 2.625q1.134 1.1 2.725 1.1M8 44V16.3h19.5v-4.8q0-3.942 2.78-6.721Q33.062 1.999 37.006 2q3.945 0 6.72 2.779T46.5 11.5h-3q0-2.7-1.894-4.6t-4.6-1.9T32.4 6.896 30.5 11.5v4.8H40V44z" }, null, -1)
  ])))
}
export default { render: render }